export default __webpack_public_path__ + "static/media/credit-card-solid.ab596771.svg";